var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'recently-deleted-button pa-1 mx-auto',
    { 'pa-5': _vm.$vuetify.breakpoint.mdAndUp } ]},[_c('transition',{attrs:{"name":"fade-rda","appear":""}},[_c('v-btn',_vm._g(_vm._b({attrs:{"depressed":"","block":"","ripple":false,"title":"View recently deleted assets"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._v(" Deleted Assets ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }